import { render, staticRenderFns } from "./ReportAporteRelativo.vue?vue&type=template&id=76fdfe63"
import script from "./ReportAporteRelativo.vue?vue&type=script&lang=js"
export * from "./ReportAporteRelativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports